const Label = ({ className, children, ...props }) => (
    <label
        className={`${className ? className : ''} label`}
        {...props}>
        {children}
    </label>
)

export default Label
